import { ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output, inject, DestroyRef } from '@angular/core';
import { UntypedFormBuilder, FormGroup } from '@angular/forms';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import * as _ from 'lodash-es';
import { GtwElementsBaseUrlsModel } from '../../../shared/_models/gtw-elements-base-urls.model';
import { MatSnackBar } from '@angular/material/snack-bar';
import { GtwSnackbarService } from '../../../shared/_services/gtw-snackbar.service';
import { forkJoin, Subscription } from 'rxjs';
import { GlobalService } from '../../../global/services/global.service';
import { WorkspaceService } from '../../../workspace/workspace.service';
import { AppService } from '../../../app.service';
import {
  buildHeaderDataShell,
  generalConfigFromGlobal,
  hydratedGlobalParams,
  normalizeFilterParams,
  rowPayloadFromActiveScreen,
} from '../../../shared/workspace-element-context';
import { JsonObjectFactoryService } from '../../../shared/_services/json-object-factory.service';
import { F7004Service } from './f7004.service';

import { safeEvalFormula, isFiniteEvalNumber } from '../../../shared/_utils/safe-eval-formula';

@Component({
    selector: 'gtw-f7004',
    templateUrl: './f7004.component.html',
    styleUrls: ['./f7004.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class F7004Component implements OnInit, OnDestroy {
  private readonly destroyRef = inject(DestroyRef);

  private readonly subs = new Subscription();

  @Output('request-grid-update') requestGridUpdate = new EventEmitter<any>();

  baseURLs: GtwElementsBaseUrlsModel = {'admin':'','api':'','custom':'','efile':'','pdfEngine':'','bulkPdfEngine':''};
  
  filterParams: any = {};
  
  globalService: any;
  appService: any = {
    USER_SETTINGS: '',
    SERVER_CONFIG: ''
  };
  GENERAL_CONFIG: any;

  // Row data from AngularJS (similar to F8916 pattern)
  rowData: any = {};

  // Component properties migrated from F7004Ctrl.js
  modalTitle = '';
  originalData: any[] = [];
  userSettings: any;
  logged_in_user: string = '';
  currentyear: string = '';
  leId: string = '';
  formName = 'F7004';
  hgt = '96%';
  cdr_no: string = '';
  leType: string = '';
  disableDate = true;
  isSaveClicked = false;
  crudLoading = false;
  minimise = false;
  showFormLoader = true;
  
  // Calendar configuration
  calendar = {
    opened: false
  };

  // Form data structure
  formData: any = {
    "addrows": [],
    "editrows": [],
    "removerows": []
  };

  // Entity and form data
  entityList: any[] = [];
  f7004FormView: any[] = [];
  formHeader: any[] = [];
  tableHeader: any[] = [];
  formList1: any[] = [];
  irsPayment: any[] = [];
  subsidiaries: any[] = [];
  formLOV: any[] = [];
  formCalcData: any[] = [];
  
  // IRS Payment fields
  routingTransNum: string = '';
  bankAccountNum: string = '';
  bankAccountType: string = '';
  paymentType: string = '';
  paymentDate: any = '';
  phoneNumber: string = '';
  acctNum: any[] = [];
  
  // Phone formatting exactly like ui-mask="(999) 999-9999" in AngularJS
  private phoneMask = '(___) ___-____';
  private lastPhoneValue = '';
  
  onPhoneInput(event: any) {
    let input = event.target;
    let newValue = input.value;
    
    // Prevent infinite loops
    if (newValue === this.lastPhoneValue) return;
    
    let digits = newValue.replace(/\D/g, '');
    
    // Limit to 10 digits
    if (digits.length > 10) {
      digits = digits.substring(0, 10);
    }
    
    let formatted = this.formatPhoneNumber(digits);
    
    this.phoneNumber = formatted;
    this.lastPhoneValue = formatted;
    input.value = formatted;
    
    // Save to server with clean digits only
    this.assignIRSPaymentValues('F7004_PHONE_NUMBER', digits);
  }
  
  onPhoneKeydown(event: any) {
    let input = event.target;
    let key = event.key;
    let cursorPos = input.selectionStart;
    
    if (key === 'Backspace') {
      event.preventDefault();
      
      let currentValue = input.value;
      let digits = currentValue.replace(/\D/g, '');
      
      if (digits.length > 0) {
        // Remove last digit
        digits = digits.substring(0, digits.length - 1);
        let formatted = this.formatPhoneNumber(digits);
        
        this.phoneNumber = formatted;
        this.lastPhoneValue = formatted;
        input.value = formatted;
        
        // Position cursor at end of digits
        setTimeout(() => {
          let newPos = formatted.indexOf('_');
          if (newPos === -1) newPos = formatted.length;
          input.setSelectionRange(newPos, newPos);
        }, 0);
        
        // Save to server
        this.assignIRSPaymentValues('F7004_PHONE_NUMBER', digits);
      }
    } else if (key === 'Delete') {
      event.preventDefault();
      // Handle delete key similar to backspace
      this.onPhoneKeydown({...event, key: 'Backspace'});
    } else if (key === 'ArrowLeft' || key === 'ArrowRight') {
      // Allow arrow keys for navigation
      return;
    } else if (/^\d$/.test(key)) {
      // Handle digit input
      event.preventDefault();
      
      let currentValue = input.value;
      let digits = currentValue.replace(/\D/g, '');
      
      if (digits.length < 10) {
        digits += key;
        let formatted = this.formatPhoneNumber(digits);
        
        this.phoneNumber = formatted;
        this.lastPhoneValue = formatted;
        input.value = formatted;
        
        // Position cursor after new digit
        setTimeout(() => {
          let newPos = formatted.indexOf('_');
          if (newPos === -1) newPos = formatted.length;
          input.setSelectionRange(newPos, newPos);
        }, 0);
        
        // Save to server
        this.assignIRSPaymentValues('F7004_PHONE_NUMBER', digits);
      }
    } else if (key.length === 1) {
      // Block other character input
      event.preventDefault();
    }
  }
  
  onPhoneFocus(event: any) {
    let input = event.target;
    if (!this.phoneNumber || this.phoneNumber === '') {
      this.phoneNumber = this.phoneMask;
      input.value = this.phoneMask;
    }
    
    // Position cursor at first underscore
    setTimeout(() => {
      let pos = input.value.indexOf('_');
      if (pos !== -1) {
        input.setSelectionRange(pos, pos);
      }
    }, 0);
  }
  
  onPhoneClick(event: any) {
    let input = event.target;
    let clickPos = input.selectionStart;
    let value = input.value;
    
    // Find nearest valid cursor position (at underscore or after last digit)
    let underscorePos = value.indexOf('_');
    if (underscorePos !== -1) {
      input.setSelectionRange(underscorePos, underscorePos);
    } else {
      input.setSelectionRange(value.length, value.length);
    }
  }
  
  private formatPhoneNumber(digits: string): string {
    let result = '';
    let digitIndex = 0;
    
    for (let i = 0; i < this.phoneMask.length; i++) {
      if (this.phoneMask[i] === '_') {
        if (digitIndex < digits.length) {
          result += digits[digitIndex];
          digitIndex++;
        } else {
          result += '_';
        }
      } else {
        result += this.phoneMask[i];
      }
    }
    
    return result;
  }
  
  // Initialize phone field when loading data from server
  initializePhoneNumber() {
    if (this.phoneNumber && this.phoneNumber.length > 0) {
      // If server returns raw number like "5555555555", format it
      let digits = this.phoneNumber.replace(/\D/g, '');
      if (digits.length > 0) {
        this.phoneNumber = this.formatPhoneNumber(digits);
        this.lastPhoneValue = this.phoneNumber;
      }
    } else {
      // Show empty mask
      this.phoneNumber = this.phoneMask;
      this.lastPhoneValue = this.phoneMask;
    }
  }

  // Bank account options
  bankAcctTypeOptions = {
    "0": {"CODE_NAME": "1", "CODE_DESC": "Checking"}, 
    "1": {"CODE_NAME": "2", "CODE_DESC": "Savings"}
  };

  // Tab configuration (like F8916)
  tabs = [
    { id: 1, name: "Form Entry", active: true },
    { id: 2, name: "Subsidiary", active: true }
  ];
  activeTab = 1;
  currentTabName = 'Form Entry';

  // Validation and calculation properties
  validRoutingNum: boolean | undefined = undefined;
  validBankAccount: boolean = false;
  validPhoneNumber: boolean = false;
  
  // Check if all validations pass
  get isValidForm(): boolean {
    const hasRoutingNum = this.routingTransNum && this.routingTransNum.trim() !== '';
    const hasBankAccount = this.bankAccountNum && this.bankAccountNum.trim() !== '';
    const hasPhoneNumber = this.phoneNumber && this.phoneNumber.trim() !== '';
    
    const routingValid = !hasRoutingNum || (this.validRoutingNum === true);
    const bankValid = !hasBankAccount || this.validBankAccount;
    const phoneValid = !hasPhoneNumber || this.validPhoneNumber;
    
    return routingValid && bankValid && phoneValid;
  }
  conditionalField: boolean = true;
  disableNumberFields: any[] = [];
  disabledLines: any[] = [];
  currentRecord: any[] = [];
  msg: string = '';
  formDates: any[] = [];
  filerYearBegin: string = '';
  filerYearEnd: string = '';
  dtmax: Date = new Date();

  /** Native <select> compare: avoids cleared selection when option values are strings vs numbers. */
  dropdownOptionCompareWith = (a: any, b: any): boolean => {
    if (a === b) {
      return true;
    }
    const sa = a === null || a === undefined ? '' : String(a).trim();
    const sb = b === null || b === undefined ? '' : String(b).trim();
    return sa === sb;
  };

  constructor(
    private jsonObjectFactory: JsonObjectFactoryService,
    private f7004Service: F7004Service,
    private _snackBar: MatSnackBar, private gtwSnackbar: GtwSnackbarService,
    private formBuilder: UntypedFormBuilder,
    private cdr: ChangeDetectorRef,
    private gtwGlobal: GlobalService,
    private gtwWorkspace: WorkspaceService,
    private gtwApp: AppService,
  ) {}

  ngOnInit(): void {
    this.applyWorkspaceContext();
    this.subs.add(this.gtwWorkspace.setTabActive.subscribe(() => {
      this.applyWorkspaceContext();
      this.init();
    }));
    this.subs.add(this.gtwGlobal.globalParamsChanged$.subscribe(() => {
      this.applyWorkspaceContext();
      this.init();
    }));
    this.init();
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  private applyWorkspaceContext(): void {
    const activeScreen = this.gtwWorkspace.workspaceFactory?.activeScreen || {};
    const header = buildHeaderDataShell(this.gtwGlobal, this.gtwApp);
    header.globalParams = hydratedGlobalParams(this.gtwGlobal, this.gtwWorkspace) || header.globalParams || {};
    this.baseURLs = generalConfigFromGlobal(this.gtwGlobal);
    this.GENERAL_CONFIG = header.generalConfigData || {};
    this.globalService = header;
    this.appService = {
      USER_SETTINGS: header.userSettingsData || {},
      SERVER_CONFIG: header.serverConfigData || {},
    };
    this.filterParams = normalizeFilterParams(activeScreen);
    this.rowData = rowPayloadFromActiveScreen(activeScreen);
    this.globalService.filterParams = this.filterParams;
    this.cdr.markForCheck();
  }

  init() {
    try {
      if (!this.globalService || !this.GENERAL_CONFIG) {
        return;
      }

      this.userSettings = this.appService.USER_SETTINGS;
      this.logged_in_user = this.userSettings?.user?.sso_id || '';
      
      // Only proceed if we have row data
      if (this.rowData && Object.keys(this.rowData).length > 0) {
        this.setupComponentData();
        this.init7004();
      }
    } catch (e) {
      console.error('Error in F7004 init:', e);
    }
  }

  private setupComponentData() {
    // Use real data from rowData parameter (like in F8916 and F1125SchE pattern)
    this.currentyear = this.rowData.TAX_YEAR || '';
    this.leId = this.rowData.LEID || '';
    this.cdr_no = this.rowData.MARS || '';
    this.leType = this.rowData.LE_TYPE || '';
    
    this.entityList = [
      {key: "Tax Year", value: this.rowData.TAX_YEAR || ''},
      {key: "LEID", value: this.rowData.LEID || ''},
      {key: "LE Name", value: this.rowData.LE_NAME || ''}
    ];

    if (this.rowData.EFILE_Y_N === 'YES') {
      this.isSaveClicked = true;
    }
  }

  init7004() {
    this.dtmax = new Date();
    this.assignTabNames(null);
    
    // Load main data first, then parallel load supporting data
    this.fetch7400records();
  }

  fetch7400records() {
    const params = { 
      "action_code": 'sl17nu', 
      "tax_year": this.rowData.TAX_YEAR, 
      "scenario": this.rowData.SCENARIO, 
      "jcd_key": this.rowData.JCD_KEY, 
      "combination_key": this.rowData.COMBINATION_KEY,
      "form_no": "7004", 
      "schedule_name": "NA", 
      "part_no": "", 
      "section_name": "NA", 
      "jcd_ta_key": null
    };

    this.jsonObjectFactory.getJSONObj(
      this.GENERAL_CONFIG.base_url + '/loadJsonObject', 
      params,
      this.globalService,
      null,
      null
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any) => {
      this.processFormData(data);
      this.originalData = _.cloneDeep(this.f7004FormView);
      this.validateSubForm(undefined, undefined, undefined);
      
      // Load supporting data in parallel after main data is loaded
      this.loadSupportingData();
      this.cdr.markForCheck();
    });
  }

  private processFormData(data: any) {
    this.modalTitle = data.jsonObject[0].ATTRIB_DESCRIPTION;
    this.formHeader = data.jsonObject.filter((item: any) => item.ROW_TYPE === "FH");
    this.tableHeader = data.jsonObject.filter((item: any) => item.ROW_TYPE === "TH");
    this.formList1 = data.jsonObject.slice(1);

    this.f7004FormView = this.formList1.filter((obj: any) => obj.ROW_TYPE !== 'TH');
    this.normalizeDropdownAttribValues(this.f7004FormView);

    this.irsPayment = this.formList1.filter((obj: any) => obj.PART_NO === 'III');
    
    // Parse IRS payment values based on LINE_NO
    for (let i = 0; i < this.irsPayment.length; i++) {
      if (this.irsPayment[i].LINE_NO == '9') {
        this.routingTransNum = this.irsPayment[i].ATTRIB_VALUE;
      } else if (this.irsPayment[i].LINE_NO == '10') {
        this.bankAccountNum = this.irsPayment[i].ATTRIB_VALUE;
      } else if (this.irsPayment[i].LINE_NO == '11') {
        this.bankAccountType = this.irsPayment[i].ATTRIB_VALUE;
      } else if (this.irsPayment[i].LINE_NO == '12') {
        this.paymentType = this.irsPayment[i].ATTRIB_VALUE;
      } else if (this.irsPayment[i].LINE_NO == '13') {
        if (this.irsPayment[i].ATTRIB_VALUE && this.irsPayment[i].ATTRIB_VALUE != 0 && this.irsPayment[i].ATTRIB_VALUE != '0') {
          this.paymentDate = this.convertToDateInputFormat(this.irsPayment[i].ATTRIB_VALUE);
        }
      } else if (this.irsPayment[i].LINE_NO == '14') {
        this.phoneNumber = this.irsPayment[i].ATTRIB_VALUE;
        // Format phone number from server data like ui-mask
        this.initializePhoneNumber();
      }
    }
    
    this.getdetails(this.bankAccountNum);
  }

  /** Align ATTRIB_VALUE with LOV option values (string, trimmed; empty for null/undefined). */
  private normalizeDropdownAttribValues(rows: any[]) {
    if (!rows) {
      return;
    }
    for (const row of rows) {
      if (String(row.EDIT_TYPE || '').toLowerCase() === 'dropdown') {
        const v = row.ATTRIB_VALUE;
        row.ATTRIB_VALUE = v === null || v === undefined ? '' : String(v).trim();
      }
    }
  }

  /**
   * After LOV loads, map ATTRIB_VALUE to option [value] (CODE_NAME). If the API stored CODE / CODE_DESC
   * or a numeric type, the select would otherwise reset to "Select" when options render.
   */
  private syncDropdownValuesWithLov(): void {
    if (!this.f7004FormView?.length || !this.formLOV?.length) {
      return;
    }
    for (const row of this.f7004FormView) {
      if (String(row.EDIT_TYPE || '').toLowerCase() !== 'dropdown') {
        continue;
      }
      const raw = row.ATTRIB_VALUE;
      if (raw === null || raw === undefined || raw === '') {
        row.ATTRIB_VALUE = '';
        continue;
      }
      const s = String(raw).trim();
      const lov = this.formLOV;
      const byCodeName = lov.find((o: any) => String(o.CODE_NAME ?? '').trim() === s);
      if (byCodeName) {
        row.ATTRIB_VALUE = String(byCodeName.CODE_NAME).trim();
        continue;
      }
      const byCode = lov.find((o: any) =>
        String(o.CODE ?? '').trim() === s ||
        String(o.CODE_KEY ?? '').trim() === s ||
        String(o.LOV_CODE ?? '').trim() === s
      );
      if (byCode) {
        row.ATTRIB_VALUE = String(byCode.CODE_NAME).trim();
        continue;
      }
      const byDesc = lov.find((o: any) => String(o.CODE_DESC ?? '').trim() === s);
      if (byDesc) {
        row.ATTRIB_VALUE = String(byDesc.CODE_NAME).trim();
      }
    }
  }

  /** Keep dirty baseline aligned after LOV sync so rows are not marked changed incorrectly. */
  private patchOriginalDataDropdownValues(): void {
    if (!this.originalData?.length || !this.f7004FormView?.length) {
      return;
    }
    for (const row of this.f7004FormView) {
      if (String(row.EDIT_TYPE || '').toLowerCase() !== 'dropdown') {
        continue;
      }
      const code = row.ATTRIB_SHORT_CODE != null ? String(row.ATTRIB_SHORT_CODE).trim() : '';
      if (!code) {
        continue;
      }
      const orig = this.originalData.find((o: any) =>
        o.ATTRIB_SHORT_CODE != null && String(o.ATTRIB_SHORT_CODE).trim() === code
      );
      if (orig) {
        orig.ATTRIB_VALUE = row.ATTRIB_VALUE;
      }
    }
  }

  private loadSupportingData() {
    // Load supporting data in parallel using forkJoin
    const lov$ = this.loadLOV();
    const dates$ = this.loadClientDates();
    const calc$ = this.loadModalCalcData();
    const subsidiary$ = this.loadSubsidiaryEntities();

    forkJoin([lov$, dates$, calc$, subsidiary$]).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: ([lovData, datesData, calcData, subsidiaryData]: [any, any, any, any]) => {
        // Process LOV data
        if (lovData != null && lovData.jsonObject != null) {
          this.formLOV = lovData.jsonObject;
        }
        this.syncDropdownValuesWithLov();
        this.patchOriginalDataDropdownValues();

        // Process dates data
        if (datesData != null && datesData.jsonObject != null) {
          this.formDates = datesData.jsonObject;
          this.filerYearBegin = this.formatDate2(this.formDates[0].FILER_TAX_YEAR_BEGIN);
          this.filerYearEnd = this.formatDate2(this.formDates[0].FILER_TAX_YEAR_END);
        }
        
        // Process calc data
        this.formCalcData = calcData.jsonObject;
        
        // Process subsidiary data
        this.subsidiaries = subsidiaryData.jsonObject;
        for (let i = 0; i < subsidiaryData.jsonObject.length; i++) {
          const formDataObj: any = {};
          formDataObj["taxYearEnd"] = this.formatDate2(subsidiaryData.jsonObject[i].TAX_YEAR_END);
          this.subsidiaries[i]["taxYearEnd"] = formDataObj["taxYearEnd"];
        }
        
        this.showFormLoader = false;
        this.cdr.markForCheck();
      },
      error: (error: any) => {
        console.error('Error loading supporting data:', error);
        this.showFormLoader = false;
        this.cdr.markForCheck();
      }
    });
  }

  private loadLOV() {
    const params = { 
      "action_code": 'sjh60s', 
      "sso_id": this.logged_in_user, 
      "tax_year": this.rowData.TAX_YEAR, 
      "scenario": this.rowData.SCENARIO,
      "jcd_key": this.rowData.JCD_KEY, 
      "form_no": "7004" 
    };
    
    return this.jsonObjectFactory.getJSONObj(
      this.GENERAL_CONFIG.base_url + '/loadJsonObject', 
      params,
      this.globalService,
      null,
      null
    );
  }

  private loadClientDates() {
    const params = { 
      "action_code": 'x9fn73', 
      "tax_year": this.rowData.TAX_YEAR, 
      "scenario": this.rowData.SCENARIO, 
      "jcd_key": this.rowData.JCD_KEY, 
      "filing_key": this.rowData.CONSOL_GROUP_KEY || '' 
    };
    
    return this.jsonObjectFactory.getJSONObj(
      this.GENERAL_CONFIG.base_url + '/loadJsonObject', 
      params,
      this.globalService,
      null,
      null
    );
  }

  private loadModalCalcData() {
    const params = { 
      "action_code": '1ubsuu', 
      "tax_year": this.rowData.TAX_YEAR, 
      "scenario": this.rowData.SCENARIO,
      "jcd_key": this.rowData.JCD_KEY, 
      "form_no": "7004",
      "schedule_name": "NA",
      "part_no": "",
      "section_name": "NA" 
    };
    
    return this.jsonObjectFactory.getJSONObj(
      this.GENERAL_CONFIG.base_url + '/loadJsonObject', 
      params,
      this.globalService,
      null,
      null
    );
  }

  private loadSubsidiaryEntities() {
    const params = { 
      "action_code": 'eqyp2c', 
      "tax_year": this.rowData.TAX_YEAR, 
      "scenario": this.rowData.SCENARIO, 
      "jcd_key": this.rowData.JCD_KEY, 
      "combination_key": this.rowData.COMBINATION_KEY, 
      "filing_key": this.rowData.CONSOL_GROUP_KEY || ''
    };

    return this.jsonObjectFactory.getJSONObj(
      this.GENERAL_CONFIG.base_url + '/loadJsonObject', 
      params,
      this.globalService,
      null,
      null
    );
  }

  // Legacy methods removed - now using parallel loading with forkJoin in loadSupportingData()

  assignTabNames(tabName: string | null) {
    if (tabName == null) {
      this.currentTabName = "Form Entry";
    } else {
      this.currentTabName = tabName;
    }
  }

  validateSubForm(entities?: any, row?: any, position?: number) {
    // Complex validation logic from original controller
    if (row == null || row.LINE_NO == '5b(v)') {
      if (this.rowData.CONSOL_GROUP_KEY == '3') {
        this.disableNumberFields = _.filter(this.f7004FormView, (o: any) => {
          return o.DATA_TYPE == 'number';
        });
        _.forEach(this.disableNumberFields, (dl: any) => {
          dl['conditionalField'] = true;
        });
      }
      
      this.disabledLines = _.filter(this.f7004FormView, (o: any) => {
        return (o.LINE_NO == '5b(v)' && o.ATTRIB_SHORT_CODE == 'F7004_LINE_5b_CHECK5');
      });
      
      if (this.disabledLines.length > 0) {
        if (this.disabledLines[0].ATTRIB_VALUE == 'true') {
          this.conditionalField = false;
        } else {
          this.conditionalField = true;
        }
      }
    }

    if (row != null) {
      if (row.DATA_TYPE == 'number') {
        for (let g = 0; g < this.formCalcData.length; g++) {
          this.calcAmt(
            this.formCalcData[g].ATTRIB_CALC_FORMULA,
            this.formCalcData[g].LINE_NO,
            this.formCalcData[g].LINE_ATTRIB_KEY,
            this.formCalcData[g].ATTRIB_COL,
            this.formCalcData[g].EDIT_TYPE
          );
        }
      } else {
        this.checkChangedValues(row);
      }
    }
  }

  checkChangedValues(row: any) {
    const oldAttribVal = this.originalData.filter((item: any) => 
      item.ATTRIB_SHORT_CODE === row.ATTRIB_SHORT_CODE.trim()
    );
    const currentTabNewAtrribVal = this.f7004FormView.filter((o: any) => {
      return o.ATTRIB_SHORT_CODE == row.ATTRIB_SHORT_CODE.trim();
    });

    if (oldAttribVal.length === 0 || currentTabNewAtrribVal.length === 0) {
      return;
    }

    let lineVal: string;
    if (currentTabNewAtrribVal[0].EDIT_TYPE == "custom_date_various") {
      const currDate = this.formatDate2(currentTabNewAtrribVal[0].ATTRIB_VALUE);
      lineVal = String(currDate);
    } else {
      lineVal = String(currentTabNewAtrribVal[0].ATTRIB_VALUE);
    }

    if (lineVal != oldAttribVal[0].ATTRIB_VALUE) {
      currentTabNewAtrribVal[0].IS_CHANGED_FLAG = 'Y';
    } else {
      currentTabNewAtrribVal[0].IS_CHANGED_FLAG = 'N';
    }
  }

  checkYr(row: any, position: number) {
    this.msg = '';
    if (row.ATTRIB_VALUE != undefined) {
      if ((isNaN(row.ATTRIB_VALUE)) || row.ATTRIB_VALUE.toString().length < 4 || 
          row.ATTRIB_VALUE <= 0 || (row.ATTRIB_VALUE > parseInt(this.currentyear))) {
        this.msg = "Input Date";
      } else {
        this.checkChangedValues(row);
      }
    }
  }

  calcAmt(formula: string, line_no: string, attrib_key: string, attrib_col: string, edit_type: string) {
    let currentFormula = formula;
    const lineFormulaArray = formula.split(/[+-/\\*\\]/);
    
    for (let i = 0; i < lineFormulaArray.length; i++) {
      if (lineFormulaArray[i].indexOf("(") > -1 && lineFormulaArray[i].indexOf(")") > -1) {
        lineFormulaArray[i] = lineFormulaArray[i].replace(/"/g, "").replace(/'/g, "").replace(/\(|\)/g, "");

        const currentTabOldAttribVal = _.filter(this.originalData, (o: any) => {
          return o.ATTRIB_SHORT_CODE == lineFormulaArray[i].trim();
        });
        
        const currentTabNewAtrribVal = _.filter(this.f7004FormView, (o: any) => {
          return o.ATTRIB_SHORT_CODE == lineFormulaArray[i].trim();
        });
        
        if (currentTabNewAtrribVal.length > 0) {
          const lineAmt = parseFloat(currentTabNewAtrribVal[0].ATTRIB_VALUE);

          const oldLineAmt = currentTabOldAttribVal && currentTabOldAttribVal.length > 0 && currentTabOldAttribVal[0]?.ATTRIB_VALUE;
          if(lineAmt != parseFloat(oldLineAmt)){
						currentTabNewAtrribVal[0].IS_CHANGED_FLAG = 'Y';
					}
          
          if (lineAmt >= 0) {
            currentFormula = currentFormula.replace("(" + lineFormulaArray[i].trim() + ")", lineAmt.toString());
          } else {
            currentFormula = currentFormula.replace("(" + lineFormulaArray[i].trim() + ")", "(" + lineAmt.toString() + ")");
          }
        }
      }
    }
    
    try {
      const calculatedVal = safeEvalFormula(currentFormula, null, 'f7004');
      if (calculatedVal !== null && typeof calculatedVal !== 'undefined' && 
          isFiniteEvalNumber(calculatedVal)) {
        
        const changedFormulaAttribVal = this.f7004FormView.filter((item: any) => 
          item.LINE_NO === line_no && item.LINE_ATTRIB_KEY === attrib_key
        );
        
        if (changedFormulaAttribVal.length > 0) {
          changedFormulaAttribVal[0].ATTRIB_VALUE = calculatedVal.toFixed();
          changedFormulaAttribVal[0].IS_CHANGED_FLAG = 'Y';
          
          if (line_no === '8' && changedFormulaAttribVal[0].ATTRIB_VALUE <= 0) {
            changedFormulaAttribVal[0].ATTRIB_VALUE = 0;
          }
        }
      }
    } catch (e) {
      console.error('Error in calculation:', e);
    }
  }

  assignIRSPaymentValues(name: string, value: any) {
    this.currentRecord = this.irsPayment.filter((obj: any) => obj.ATTRIB_SHORT_CODE == name);
    
    if (this.currentRecord.length > 0 && value !== undefined) {
      // Skip if value hasn't changed
      if (this.currentRecord[0].ATTRIB_VALUE === value) {
        return;
      }
      
      if (name == 'F7004_ROUTING_NUM') {
        this.currentRecord[0].ATTRIB_VALUE = value;
        // Exactly like AngularJS - same regex pattern (total 9 digits)  
        const routingNoRegex = /^((0[0-9])|(1[0-2])|(2[1-9])|(3[0-2]))([0-9]{7})$/;
        this.validRoutingNum = routingNoRegex.test(value);
      } else if (name == 'F7004_PAYMENT_DATE') {
        // Save as MM/dd/yyyy format like AngularJS
        this.currentRecord[0].ATTRIB_VALUE = this.formatDate2(value);
      } else if (name == 'F7004_PHONE_NUMBER') {
        this.currentRecord[0].ATTRIB_VALUE = value;
        // Don't format here since onPhoneInput already handles it
      } else {
        this.currentRecord[0].ATTRIB_VALUE = value;
      }
      
      this.checkChangedValues(this.currentRecord[0]);
    }
  }

  getViewdetails(value: any) {
    if (value != undefined) {
      this.bankAccountNum = this.acctNum.length > 0 ? this.acctNum[0].ATTRIB_VALUE : value;
    }
  }

  getdetails(value: any) {
    this.acctNum = this.irsPayment.filter((obj: any) => obj.ATTRIB_SHORT_CODE == 'F7004_ACCOUNT_NUM');
    const trailingCharsIntactCount = 4;
    if (value != undefined && this.acctNum.length > 0) {
      this.acctNum[0].ATTRIB_VALUE = value;
      const maskedValue = new Array(value.length - trailingCharsIntactCount + 1).join('x') + 
                         value.slice(-trailingCharsIntactCount);
      this.bankAccountNum = maskedValue;
    }
  }


  formatDate(row: any) {
    row["taxyearBE"] = this.formatDate2(row.ATTRIB_VALUE);
    this.checkChangedValues(row);
  }

  formatDate2(date: any): string {
    if (!date) return '';
    const d = new Date(date);
    return (d.getMonth() + 1).toString().padStart(2, '0') + '/' + 
           d.getDate().toString().padStart(2, '0') + '/' + 
           d.getFullYear().toString();
  }

  convertToDateInputFormat(date: any): string {
    if (!date) return '';
    
    // If it's already in YYYY-MM-DD format, return as is
    if (typeof date === 'string' && date.match(/^\d{4}-\d{2}-\d{2}$/)) {
      return date;
    }
    
    const d = new Date(date);
    if (isNaN(d.getTime())) return '';
    
    // Convert to YYYY-MM-DD format for HTML5 date input
    return d.getFullYear().toString() + '-' + 
           (d.getMonth() + 1).toString().padStart(2, '0') + '-' + 
           d.getDate().toString().padStart(2, '0');
  }

  openCalendar(row: any) {
    row['isOpen'] = true;
  }

  openCalendar1() {
    this.calendar.opened = true;
  }

  onCheckboxChange(event: Event, row: any, index: number) {
    const target = event.target as HTMLInputElement;
    row.ATTRIB_VALUE = target.checked ? 'true' : 'false';
    this.validateSubForm(this.f7004FormView, row, index);
  }

  onDropDownChange(event: Event, row: any, index: number) {
    row.ATTRIB_VALUE = event;
    this.validateSubForm(this.f7004FormView, row, index);
  }

  save() {
    this.isSaveClicked = true;
    
    if (this.msg != '') {
      this.gtwSnackbar.openSnackBar("Please enter a valid Calendar Year", 'gtw-snackbar--red', true, 4);
      this.isSaveClicked = false;
      return;
    }
    
    // Keep original AngularJS validation logic - exact same condition
    console.log(1, this.validRoutingNum)
    if (!this.validRoutingNum && this.validRoutingNum !== undefined) {
      this.gtwSnackbar.openSnackBar("Please enter a valid Routing Transit Num", 'gtw-snackbar--red', true, 4);
      this.isSaveClicked = false;
      return;
    }

    const saveData = this.f7004FormView.filter((item: any) => item.IS_CHANGED_FLAG === 'Y');
    
    if (saveData.length == 0) {
      this.gtwSnackbar.openSnackBar("No changes to save.", 'gtw-snackbar--yellow', true, 4);
      this.isSaveClicked = false;
      return;
    }

    // Build save data structure exactly like original AngularJS
    const f7004SaveDtls: any[] = [];
    for (let i = 0; i < saveData.length; i++) {
      const returnObj: any = {};
      
      // All fields from original F7004Ctrl.js
      returnObj['form_name'] = saveData[i].FORM_NAME;
      returnObj['part_no'] = saveData[i].PART_NO;
      returnObj['line_no'] = saveData[i].LINE_NO;
      returnObj['schd_no'] = saveData[i].SCHEDULE_NAME;
      returnObj['section_name'] = saveData[i].SECTION_NAME;
      returnObj['combination_key'] = saveData[i].COMBINATION_KEY;
      returnObj['form_key'] = saveData[i].FORM_KEY;
      returnObj['form_line_key'] = saveData[i].FORM_LINE_KEY;
      returnObj['line_attrib_key'] = saveData[i].LINE_ATTRIB_KEY;
      returnObj['attrib_type'] = saveData[i].ATTRIB_TYPE;
      returnObj['attrib_prop_key'] = saveData[i].ATTRIB_PROP_KEY;
      returnObj['acct_ref_key'] = saveData[i].ACCT_REF_KEY;
      returnObj['attrib_value'] = saveData[i].ATTRIB_VALUE;
      returnObj['trans_details_key'] = saveData[i].TRANS_DETAILS_KEY;
      returnObj['trans_type_key'] = saveData[i].TRANS_TYPE_KEY;
      returnObj['is_changed_flag'] = saveData[i].IS_CHANGED_FLAG;
      returnObj['occurrence'] = (saveData[i].OCCURRENCE != null) ? parseInt(saveData[i].OCCURRENCE) : 1;
      
      f7004SaveDtls.push(returnObj);
    }

    // Build returnClobSettingsObj exactly like original AngularJS (basic fields only)
    const returnClobSettingsObj = {
      'sso_id': this.logged_in_user,
      'screen_key': this.rowData.SCREEN_KEY || this.globalService?.globalParams?.screen_key || '',
      'form_name': this.f7004FormView[0].FORM_NAME,
      'combination_key': this.f7004FormView[0].COMBINATION_KEY
    };



    this.f7004Service.savef7004(this.GENERAL_CONFIG.base_url, returnClobSettingsObj, f7004SaveDtls, this.globalService, this.filterParams, this.rowData).pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(
        (response: any) => {
          this.isSaveClicked = false;
          
          if (response.errorMessage && response.errorMessage !== 'null') {
            this.gtwSnackbar.openSnackBar(response.errorMessage, 'gtw-snackbar--red', true, 4);
          } else {
            // Show success snackBar
            this.gtwSnackbar.openSnackBar('Form has been successfully saved/updated', 'gtw-snackbar--green', true, 4);
            
            // Emit using @Output (AngularJS will close modal automatically)
            this.requestGridUpdate.emit('refresh');
          }
          this.cdr.markForCheck();
        },
        (error: any) => {
          this.isSaveClicked = false;
          this.gtwSnackbar.openSnackBar('Error occurred while saving. Please try again.', 'gtw-snackbar--red', true, 4);
          this.cdr.markForCheck();
        }
      );
  }

  reset() {
    this.f7004FormView = _.cloneDeep(this.originalData);
    this.validateSubForm(undefined, undefined, undefined);
    
    // Reset IRS payment fields
    const irsPaymentReset = this.originalData.filter((obj: any) => obj.PART_NO === 'III');
    
    for (let i = 0; i < irsPaymentReset.length; i++) {
      if (irsPaymentReset[i].LINE_NO == '9') {
        this.routingTransNum = irsPaymentReset[i].ATTRIB_VALUE;
      } else if (irsPaymentReset[i].LINE_NO == '10') {
        this.bankAccountNum = irsPaymentReset[i].ATTRIB_VALUE;
      } else if (irsPaymentReset[i].LINE_NO == '11') {
        this.bankAccountType = irsPaymentReset[i].ATTRIB_VALUE;
      } else if (irsPaymentReset[i].LINE_NO == '12') {
        this.paymentType = irsPaymentReset[i].ATTRIB_VALUE;
      } else if (irsPaymentReset[i].LINE_NO == '13') {
        if (irsPaymentReset[i].ATTRIB_VALUE && irsPaymentReset[i].ATTRIB_VALUE != 0 && irsPaymentReset[i].ATTRIB_VALUE != '0') {
          this.paymentDate = this.convertToDateInputFormat(irsPaymentReset[i].ATTRIB_VALUE);
        }
      } else if (irsPaymentReset[i].LINE_NO == '14') {
        this.phoneNumber = irsPaymentReset[i].ATTRIB_VALUE;
        // Format phone number from server data like ui-mask
        this.initializePhoneNumber();
      }
    }
    
    this.getdetails(this.bankAccountNum);
  }

  cancel() {
    // Emit cancel event to close modal (AngularJS integration)
    this.requestGridUpdate.emit('cancel');
  }

  // Track by function for ngFor
  itemTracker(index: number, item: any): any {
    return item ? item.LINE_ATTRIB_KEY || item.LEID || index : index;
  }

  // Filter function for form display  
  filterFormDisplay(item: any): boolean {
    return item.IS_FORM_DISPLAY === 'Y' && item.ATTRIB_COL === 'a' && item.ROW_TYPE !== 'IP';
  }
} 